import { Ruthie } from '../components/Ruthie';
import PageTitle from '../components/PageTitle';

export default function RuthiePage() {
  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border-border">
        <PageTitle title="Data Architect" />
        <p className="text-sm text-muted-foreground mt-1">
          Design your semantic layer through natural conversation with Ruthie.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Ruthie showHistory={true} />
      </div>
    </div>
  );
}
